module.exports = __webpack_public_path__ + "static/media/galleryImg11.dd9801dc.jpg";